/* This file is autogenerated, see readme.md for instructions */
import EmojiPickerSvgIcon from '@bloomreach/banana-theme/icons/emoji-picker.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EmojiPickerIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EmojiPickerSvgIcon />
    </Icon>
  );
});

EmojiPickerIcon.displayName = 'EmojiPickerIcon';

export default EmojiPickerIcon;
